<script>
import Chip from "./Chip";
import Statuses from "./Statuses";

export default {
  data() {
    return {
      showStatuses: false
    };
  },

  props: {
    status: {
      type: Object,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    }
  },

  components: {
    Chip,
    Statuses
  }
};
</script>

<template>
  <div>
    <chip
      :status="status.name"
      :color="status.color"
      :icon="status.icon"
      description="clique para saber mais"
      :statuses="statuses"
      @click="showStatuses = true"
    />
    <statuses
      :orderActive="status.order"
      :statuses="statuses"
      :visible="showStatuses"
      @close="showStatuses = false"
    />
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Status/Index.vue